export default __webpack_public_path__ + "static/media/WfsSearchInput.fa56a027.less";